document.addEventListener("DOMContentLoaded", function () {
const form = document.getElementById("autriApplicationForm");

if (!form) {
return;
}

const positionCheckboxes = Array.from(
form.querySelectorAll("[data-position]")
);

const questionGroups = Array.from(
form.querySelectorAll("[data-question-group]")
);

const positionError = document.getElementById("positionError");
const contactName = document.getElementById("autriContactName");
const applicationBody = document.getElementById("autriApplicationBody");

function updatePositionQuestions() {
questionGroups.forEach(function (group) {
const position = group.dataset.questionGroup;

const matchingCheckbox = positionCheckboxes.find(function (checkbox) {
return checkbox.dataset.position === position;
});

if (matchingCheckbox && matchingCheckbox.checked) {
group.classList.add("active");
} else {
group.classList.remove("active");
}
});

const atLeastOneSelected = positionCheckboxes.some(function (checkbox) {
return checkbox.checked;
});

if (atLeastOneSelected && positionError) {
positionError.hidden = true;
}
}

positionCheckboxes.forEach(function (checkbox) {
checkbox.addEventListener("change", updatePositionQuestions);
});

function valueOf(id) {
const element = document.getElementById(id);

if (!element) {
return "";
}

return element.value ? element.value.trim() : "";
}

function yesNo(id) {
const element = document.getElementById(id);

return element && element.checked ? "Yes" : "No";
}

function formatDate(dateString) {
if (!dateString) {
return "Not provided";
}

const parts = dateString.split("-");

if (parts.length !== 3) {
return dateString;
}

return parts[1] + "/" + parts[2] + "/" + parts[0];
}

function getSelectedPositions() {
return positionCheckboxes
.filter(function (checkbox) {
return checkbox.checked;
})
.map(function (checkbox) {
return checkbox.dataset.positionLabel || checkbox.value;
});
}

function addPositionAnswers(lines, position) {
const group = form.querySelector(
'[data-question-group="' + position + '"]'
);

if (!group) {
return;
}

const fields = group.querySelectorAll("[data-label]");

fields.forEach(function (field) {
const label = field.dataset.label || "Answer";
const answer = field.value ? field.value.trim() : "";

lines.push(label + ": " + (answer || "Not provided"));
});
}

function buildApplicationMessage() {
const firstName = valueOf("firstName");
const lastName = valueOf("lastName");
const selectedPositions = getSelectedPositions();

const lines = [];

lines.push("AUTRI STAFFING, LLC.");
lines.push("EMPLOYMENT APPLICATION");
lines.push("");
lines.push("PERSONAL INFORMATION");
lines.push("------------------------------");
lines.push("Name: " + firstName + " " + lastName);
lines.push("Date of Birth: " + formatDate(valueOf("dateOfBirth")));
lines.push("Email: " + valueOf("email"));
lines.push("Phone: " + valueOf("phone"));
lines.push(
"Current Address: " +
valueOf("streetAddress") +
", " +
valueOf("city") +
", " +
valueOf("state") +
" " +
valueOf("zip")
);

lines.push("");
lines.push("POSITIONS OF INTEREST");
lines.push("------------------------------");
lines.push(selectedPositions.join(", "));

selectedPositions.forEach(function (positionLabel) {
const checkbox = positionCheckboxes.find(function (item) {
return (
(item.dataset.positionLabel || item.value) === positionLabel
);
});

if (!checkbox) {
return;
}

lines.push("");
lines.push(positionLabel.toUpperCase());
lines.push("------------------------------");
addPositionAnswers(lines, checkbox.dataset.position);
});

lines.push("");
lines.push("EMPLOYMENT INFORMATION");
lines.push("------------------------------");
lines.push(
"Date Available: " +
formatDate(valueOf("availability"))
);
lines.push(
"Preferred Schedule: " +
(valueOf("schedule") || "Not provided")
);
lines.push(
"Recent Work Experience: " +
(valueOf("experience") || "Not provided")
);

lines.push("");
lines.push("GENERAL WORK REQUIREMENTS");
lines.push("------------------------------");
lines.push(
"Reliable attendance acknowledgment: " +
yesNo("reliableAttendance")
);
lines.push(
"Safety policy acknowledgment: " +
yesNo("safetyAgreement")
);
lines.push(
"Background / credential screening acknowledgment: " +
yesNo("backgroundAcknowledgment")
);

lines.push("");
lines.push("APPLICANT CERTIFICATION");
lines.push("------------------------------");
lines.push(
"Certification accepted: " +
yesNo("certification")
);
lines.push(
"Electronic Signature: " +
valueOf("signature")
);

return lines.join("\n");
}

form.addEventListener("submit", function (event) {
const selectedPositions = getSelectedPositions();

if (selectedPositions.length === 0) {
event.preventDefault();

if (positionError) {
positionError.hidden = false;
positionError.scrollIntoView({
behavior: "smooth",
block: "center"
});
}

return;
}

const firstName = valueOf("firstName");
const lastName = valueOf("lastName");

contactName.value = (firstName + " " + lastName).trim();
applicationBody.value = buildApplicationMessage();
});

updatePositionQuestions();
});
